export const isCookieRefreshModeEnabled = () => true;
